import React, { useCallback, useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { Button, Box } from '@mui/material';
import { techLayers } from '../../../static-data/DropdownOptions';
import { getTestSuites } from '../../../modules/testsuites';
import { useParams } from 'react-router-dom';
import {
  Alert,
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import TestSuiteTableAction from '../../project-dashboard/test-suites/TestSuiteTableAction';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const SetDefaultsValues = ({ formValues, setFormValues }) => {
  const [data, setData] = useState([]);
  const [selectedTestSuites, setTestSuites] = useState(
    formValues?.testsuites || []
  );
  const [loading, setLoading] = useState(true);
  const [openAdd, setOpenAdd] = useState(false); 
  const { projectId } = useParams();
  const fetchTestSuitesData = async () => {
    try {
      const response = await getTestSuites(projectId, 0, 'all', '', 'active');
      setData(response.data);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTestSuitesData();
  }, []);

  const handleChangeSuite = (event) => {
    const {
      target: { value },
    } = event;
    setTestSuites(typeof value === 'string' ? value.split(',') : value);
    setFormValues({
      ...formValues,
      testSuites: typeof value === 'string' ? value.split(',') : value,
    });
  };

  const handleDropdownChange = useCallback(
    (id, value) => {
      const newValue = value === '' ? null : value;
      setFormValues((prevData) => ({
        ...prevData,
        [id]: newValue,
      }));
    },
    [setFormValues]
  );

  useEffect(() => {
    if (formValues?.testSuites?.length > 0) {
      setTestSuites(formValues.testSuites);
    }
  },[formValues?.testSuites]);
  if (loading) {
    return <p className="text-center my-4 text-muted">Processing Data...</p>;
  }
  return (
    <>
      <Form>
        {data?.length === 0 ? (
          <Alert severity="warning">
            No test suites found. Please create a test suite to add test cases, as
            they are required for adding test cases.
          </Alert>
        ) : (
          <Row className="my-3">
            <Col>
              <Form.Group controlId="testsuites">
                <Form.Label className="required">Test Suite</Form.Label>
                <FormControl sx={{ width: '100%', p: 0 }}>
                  <Select
                    labelId="test-suites-label"
                    id="test-suites"
                    multiple
                    sx={{
                      maxHeight: '48px',
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ced4da',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ced4da',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ced4da',
                      },
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                    value={selectedTestSuites}
                    onChange={handleChangeSuite}
                    input={<OutlinedInput placeholder="Test Suites" />}
                    renderValue={
                      selectedTestSuites?.length === 0
                        ? () => 'None'
                        : (selected) => {
                            return selected
                              .map(
                                (id) =>
                                  data.find((suite) => suite.id === id)?.name
                              )
                              .join(', ');
                          }
                    }
                    MenuProps={MenuProps}>
                    {data.map((suite) => (
                      <MenuItem
                        key={suite.name}
                        value={suite.id}
                        >
                        <Checkbox
                          disableRipple
                          checked={selectedTestSuites.includes(suite.id)}
                        />
                        <ListItemText primary={suite.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Box sx={{ textAlign: 'left', mt: 0.5 }}>
                  <Button
                    variant="text"
                    color="primary"
                    size="small"
                    sx={{ p: 0, minWidth: 'auto', textTransform: 'none' }}
                    onClick={() => setOpenAdd(true)}> 
                    + Add Test Suite
                  </Button>
                </Box>
              </Form.Group>
            </Col>
          </Row>
        )}
      </Form>
       <TestSuiteTableAction
        fetchTestSuitesData={fetchTestSuitesData}
        setOpenModal={setOpenAdd}
        open={openAdd}
        mode="add"
        setMode={() => {}}
        selectedSuite={null}
        setSelectedSuite={() => {}}
      />
    </>
  );
};

export default SetDefaultsValues;
